import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../mock";
import { Truck, Users, Warehouse, Star, PackageCheck, ListChecks, Upload, Search, Palette, GraduationCap, ArrowRight } from "lucide-react";

const iconMap = {
  truck: Truck,
  users: Users,
  warehouse: Warehouse,
  star: Star,
  truckBox: PackageCheck,
  list: ListChecks,
  upload: Upload,
  search: Search,
  palette: Palette,
};

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-head">
          <span className="kicker">What We Do</span>
          <h2>Built to keep your wheels turning</h2>
          <p>Whether you run one truck or a growing fleet, we handle the back office so your revenue miles stay maximized.</p>
        </div>
        <div className="service-grid">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.icon] || Truck;
            return (
              <div className="service-card" key={i}>
                <div className="icon-badge">
                  <Icon strokeWidth={2} />
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                {s.fee && <span className="fee-badge">{s.fee}</span>}
                {s.consult && (
                  <button className="svc-consult-btn" onClick={() => window.dispatchEvent(new Event("open-consultation"))}>
                    Book a consultation →
                  </button>
                )}
              </div>
            );
          })}
          <div className="service-card svc-training" data-testid="service-training-card">
            <div className="icon-badge"><GraduationCap strokeWidth={2} /></div>
            <h3>Carrier Sourcing &amp; Dispatching Training</h3>
            <p>Learn how to source carriers and dispatch loads with our 10-module masterclass — quizzes, glossary, and interactive games included.</p>
            <span className="fee-badge">$50 deposit · $175 full</span>
            <Link to="/training" className="svc-consult-btn" data-testid="service-training-link">Explore the course <ArrowRight size={14} /></Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
